module.exports = __webpack_public_path__ + "static/p05_back-a9e8420205d57b28d902013617456b09.jpg";